import React from 'react';
import './TimeSlotList.css';

const getSlots = (date) => {
  const slots = [];
  for (let h = 13; h <= 22; h++) {
    for (let m = 0; m < 60; m += 30) {
      const time = `${String(h).padStart(2, '0')}:${m === 0 ? '00' : '30'}`;
      let types = [];
      if (h < 14 || (h === 14 && m === 0)) {
        types = ['Chic Lunch', 'À la Carte'];
      } else if (h === 14 && m === 30) {
        types = ['À la Carte'];
      } else {
        types = ['Dinner'];
      }
      slots.push({ time, types });
    }
  }
  return slots;
};

const TimeSlotList = ({ onSelectTimeSlot, selectedDate, selectedTime, guestCount, onDateChange, selectedDateIdx, datesArr }) => {
  const slots = getSlots(selectedDate);
  let filteredSlots = slots;
  if (selectedTime !== 'All Times') {
    filteredSlots = slots.filter(slot => slot.time === selectedTime);
  }
  const slotButtons = [];
  filteredSlots.forEach(slot => {
    slot.types.forEach(type => {
      slotButtons.push({ time: slot.time, type });
    });
  });

  return (
    <div className="time-slots-section">
      <div className="date-row">
          <div className="date-header">
          <div className="date-title">{selectedDate.toLocaleString('en-US', { weekday: 'short' })}, {selectedDate.getDate()} {selectedDate.toLocaleString('default', { month: 'short' })}</div>
            <div className="date-navigation">
            <button className="nav-button prev" onClick={() => onDateChange(Math.max(selectedDateIdx - 1, 0))} disabled={selectedDateIdx === 0}>&#10094;</button>
            <button className="nav-button next" onClick={() => onDateChange(Math.min(selectedDateIdx + 1, datesArr.length - 1))} disabled={selectedDateIdx === datesArr.length - 1}>&#10095;</button>
          </div>
        </div>
        <div className="time-slots-grid-modern">
          {slotButtons.map((slot, idx) => (
            <button
              key={slot.time + slot.type}
              className="modern-slot-btn"
              onClick={() => onSelectTimeSlot(
                slot.time,
                slot.type,
                `${selectedDate.toLocaleString('en-US', { weekday: 'short' })}, ${selectedDate.getDate()} ${selectedDate.toLocaleString('default', { month: 'short' })}`
              )}
            >
              <div className="modern-slot-time">{slot.time}</div>
              <div className="modern-slot-type">{slot.type}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TimeSlotList; 